import { useEffect, useState } from 'react';
import styled from 'styled-components';

const BUTTON_WIDTH = 160;

const Button = styled.button`
  position: fixed;
  top: ${props => props.$top}px;
  left: ${props => props.$left}px;
  background-color: ${({ theme }) => theme.colors.brown};
  color: ${({ theme }) => theme.colors.paper};
  border: 1px solid ${({ theme }) => theme.colors.brownDark};
  border-radius: 8px;
  padding: 0.6rem 1.2rem;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 1100;
  transition: all 0.2s ease;
  font-family: ${({ theme }) => theme.fonts.body};

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
    background-color: ${({ theme }) => theme.colors.brownDark};
  }

  &:active {
    transform: translateY(0);
  }

  ${props => props.$visible ? `
    opacity: 1;
    pointer-events: auto;
  ` : `
    opacity: 0;
    pointer-events: none;
  `}
`;

const TweetSelectionButton = ({ selection, selectionRect, visible, onTweet }) => {
  const [position, setPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (!selectionRect || !visible) {
      return;
    }

    if (typeof window === 'undefined') {
      return;
    }

    const viewportWidth = window.innerWidth;
    const viewportLeft = selectionRect.left - window.scrollX;
    const viewportTop = selectionRect.top - window.scrollY;
    const selectionCenter = viewportLeft + (selectionRect.width || 0) / 2;
    const tentativeLeft = selectionCenter - BUTTON_WIDTH / 2;
    const maxLeft = viewportWidth - BUTTON_WIDTH - 20;
    const constrainedMaxLeft = Math.max(20, maxLeft);
    const left = Math.min(
      constrainedMaxLeft,
      Math.max(20, tentativeLeft)
    );

    const top = viewportTop - 48;

    setPosition({ top, left });
  }, [selectionRect, visible]);

  if (!visible || !selection?.text?.trim()) {
    return null;
  }

  return (
    <Button
      type="button"
      onClick={onTweet}
      $top={position.top}
      $left={position.left}
      $visible={visible}
      aria-label="Tweet highlighted text"
    >
      Tweet quote
    </Button>
  );
};

export default TweetSelectionButton;

